import axios from 'axios'

export function getCookie(name) {
  var value = '; ' + document.cookie
  var parts = value.split('; ' + name + '=')
  if (parts.length == 2) return parts.pop().split(';').shift()
}

const getheaders = () => ({
  Accept: 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
})

axios.defaults.baseURL = '/safalta-app/participants/api/'

const post = async (url, data, headers = {}) => {
  try {
    const response = await axios.post(url, data, {
      headers: getheaders(),
      ...headers,
    })
    return response
  } catch (error) {
    console.log(error)
    if (error.response.status === 500) {
      alert('Internal server error. Please try again later.')
    }
    return error.response
  }
}

export const get = async (url) => {
  try {
    const response = await axios.get(url, { headers: getheaders() })
    return response
  } catch (error) {
    console.log(error)
    if (error.response.status === 500) {
      alert('Internal server error. Please try again later.')
    }
    return error.response
  }
}

export const sendOtpApi = async (mobile) => {
  return await post('otp/send/', { mobile: mobile })
}

export const verifyOTPApi = async ({ mobile, otp }) => {
  return post('mobile-login/', { mobile, otp })
}

export const statusCheck = async () => {
  return get('status-check/')
}

export const updateParticipantInfo = async (data) => {
  return post('update-participant/', data)
}

export const getStatesList = () => {
  return get('states-list/')
}

// export const getCityListByState = (stateId) => {
//   return get(`city-list/?state=${stateId}`)
// }

export const getCollegeListByDistrict = (districtId) => {
  return get(`college-list/?district=${districtId}`)
}

export const getDistricteListByState = (stateId) => {
  return get(`district-list/?state=${stateId}`)
}